import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArtigoCssbuySheetGuia from "@/pages/artigo/cssbuy-sheet-guia-completo/page";
import ArtigoCssbuyVsPandabuy from "@/pages/artigo/cssbuy-vs-pandabuy/page";
import ArtigoSegurancaCssbuy from "@/pages/artigo/seguranca-cssbuy-guia/page";
import ArtigoNikeCssbuy from "@/pages/artigo/melhores-links-nike-cssbuy/page";
import ArtigoComoUsarCssbuy from "@/pages/artigo/como-usar-cssbuy-iniciantes/page";
import ArtigoFreteBrasil from "@/pages/artigo/cssbuy-frete-brasil-guia/page";
import ArtigoPortugal from "@/pages/artigo/cssbuy-portugal-compras/page";
import ArtigoYupoo from "@/pages/artigo/marcas-cssbuy-yupoo-2026/page";
import ArtigoQC from "@/pages/artigo/qc-cssbuy-guia-definitivo/page";
import ArtigoAgentes from "@/pages/artigo/melhores-agentes-china-2026/page";
import ArtigoTenis from "@/pages/artigo/cssbuy-tenis-melhores-links/page";
import ArtigoHaul from "@/pages/artigo/cssbuy-haul-montagem-guia/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/cssbuy-sheet-guia-completo",
    element: <ArtigoCssbuySheetGuia />,
  },
  {
    path: "/artigo/cssbuy-vs-pandabuy",
    element: <ArtigoCssbuyVsPandabuy />,
  },
  {
    path: "/artigo/seguranca-cssbuy-guia",
    element: <ArtigoSegurancaCssbuy />,
  },
  {
    path: "/artigo/melhores-links-nike-cssbuy",
    element: <ArtigoNikeCssbuy />,
  },
  {
    path: "/artigo/como-usar-cssbuy-iniciantes",
    element: <ArtigoComoUsarCssbuy />,
  },
  {
    path: "/artigo/cssbuy-frete-brasil-guia",
    element: <ArtigoFreteBrasil />,
  },
  {
    path: "/artigo/cssbuy-portugal-compras",
    element: <ArtigoPortugal />,
  },
  {
    path: "/artigo/marcas-cssbuy-yupoo-2026",
    element: <ArtigoYupoo />,
  },
  {
    path: "/artigo/qc-cssbuy-guia-definitivo",
    element: <ArtigoQC />,
  },
  {
    path: "/artigo/melhores-agentes-china-2026",
    element: <ArtigoAgentes />,
  },
  {
    path: "/artigo/cssbuy-tenis-melhores-links",
    element: <ArtigoTenis />,
  },
  {
    path: "/artigo/cssbuy-haul-montagem-guia",
    element: <ArtigoHaul />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;